module.exports = __webpack_public_path__ + "img/no-data.081aeef2.png";